import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import ComingSoonContent from '../components/coming-soon/ComingSoon';

const ComingSoon = () => {
  const { user } = useAuth();
  return <ComingSoonContent />;
};

export default ComingSoon;